import type { Theme } from './types';

/**
 * NGỌC BÍCH — nền sáng, ngọc lục bảo, cột trái, chữ tiêu đề có chân.
 *
 * Đây là giao diện đi xa nhất khỏi phần còn lại của kho, và đó là chủ đích. Nền sáng
 * đổi toàn bộ cảm giác của trang: bóng đổ nhẹ thay cho tương phản mạnh, viền mảnh thay
 * cho khối đặc, khoảng trắng rộng thay cho mật độ dày. Cột điều hướng bên trái đọc
 * theo chiều dọc chứ không quét ngang. Bộ chữ có chân ở tiêu đề gợi tới sổ sách và
 * nhà băng chứ không phải phòng máy.
 *
 * Tính cách: điềm đạm, truyền thống, đáng tin — hợp thương hiệu bán lô đề như một
 * dịch vụ lâu năm chứ không phải một trò chơi điện tử.
 */
export const ngocBich: Theme = {
  id: 'ngoc-bich',
  brandName: 'Ngọc Bích',
  tagline: 'Nền sáng, ngọc lục bảo, cột trái — điềm đạm và truyền thống.',

  scheme: 'light',
  layout: 'sidebar',
  navStyle: 'pill',
  mark: 'la-ngoc',

  fonts: {
    display: "'Lora'",
    body: "'Be Vietnam Pro'",
    href: 'https://fonts.googleapis.com/css2?family=Lora:wght@500;600;700&family=Be+Vietnam+Pro:wght@400;500;600;700&display=swap',
  },

  tokens: {
    // Nền giấy ấm thay vì trắng tinh: trắng tinh trên màn hình lớn chói mắt sau
    // một giờ, và sắc ấm nhẹ làm màu ngọc bên cạnh nó trông sâu hơn.
    'bg-root': '#f4f2ec',
    'bg-surface': '#ffffff',
    'bg-raised': '#faf9f5',
    'bg-overlay': '#ffffff',
    'bg-input': '#ffffff',
    'bg-hover': '#eef1ee',

    brand: '#0f6b4f',
    'brand-strong': '#0a553e',
    'brand-dim': '#9cc3b4',
    'brand-contrast': '#ffffff',
    accent: '#3d4b8f',

    positive: '#15803d',
    'positive-dim': '#d3ead9',
    negative: '#b3261e',
    'negative-dim': '#f6dcda',
    warning: '#a16207',
    info: '#3d4b8f',
    'odds-up': '#15803d',
    'odds-down': '#b3261e',

    'text-primary': '#1a201d',
    'text-secondary': '#4f5a55',
    'text-muted': '#7c8781',
    'text-disabled': '#a8b0ac',
    'text-on-brand': '#ffffff',
    'text-inverse': '#ffffff',

    border: '#e0ddd4',
    'border-strong': '#c8c4b8',

    // Bóng nhuốm sắc xanh của màu chủ đạo thay vì đen thuần: đen thuần trên nền giấy
    // trông bẩn, còn bóng cùng tông thì tách khối mà vẫn giữ trang sạch.
    'shadow-sm': '0 1px 2px rgb(26 60 48 / 6%)',
    'shadow-md': '0 4px 16px rgb(26 60 48 / 9%)',
    'shadow-lg': '0 16px 40px rgb(26 60 48 / 13%)',

    'font-display': "'Lora', Georgia, 'Times New Roman', serif",
    'font-sans': "'Be Vietnam Pro', 'Segoe UI', system-ui, sans-serif",

    'radius-sm': '6px',
    'radius-md': '10px',
    'radius-lg': '16px',
    'radius-xl': '24px',
    /* `--radius-full` la khoa hinh VIEN THUOC (the, nhan, tab), khong phai hinh tron
       tuyet doi — khong cho nao dung no cho anh dai dien hay cham tron. Nen mot thuong
       hieu lay goc vuong lam nhan dien duoc phep vuong hoa ca nhung cho nay; de nguyen
       999px thi nut chinh bo tron lop lop giua mot trang toan goc nhon, nhin ra ngay
       la hai bo quy tac danh nhau.
       Giu vien thuoc — hop ngon ngu bo tron mem cua giao dien nay. */
    'radius-full': '999px',

    // Thoáng hơn hẳn: thanh trên cao hơn, nội dung hẹp lại để dòng chữ không dài quá tầm mắt.
    'header-height': '68px',
    'content-max': '1360px',
    'sidebar-width': '236px',
    'brand-tracking': '0.01em',
    'label-tracking': '0.01em',
    'label-transform': 'none',
  },
};
